'use client';

import { Stack } from '@mui/material';

import { EntryPageContentContainer } from '@campaign-manager/app/ui/react/features/EntryPageContentContainer';
import { useLayoutContext } from '@campaign-manager/feature/context/LayoutContext';
import { ChallengedButton } from '@campaign-manager/react/components';

export default function Index() {
  const { project } = useLayoutContext();

  return (
    <EntryPageContentContainer title="Welcome to the Campaign Manager">
      <Stack
        sx={{
          gap: 2,
        }}
      >
        <ChallengedButton
          href="/auth/login"
          variant="contained"
          size="large"
        >
          Log in
        </ChallengedButton>
        {project && (
          <ChallengedButton
            href="/register"
            variant="outlined"
            color="secondary"
            size="large"
          >
            Register as advertiser
          </ChallengedButton>
        )}
      </Stack>
    </EntryPageContentContainer>
  );
}
